






















import { namespace } from 'vuex-class';
import { Vue, Component } from 'vue-property-decorator';
import { differenceInBusinessDays } from 'date-fns';

import { IUpsell } from '@/interfaces/Upsell';
import { ITargetContentLink } from '@/interfaces/TargetContentLink';

import TraceableError from '@/classes/TraceableError';

import CheckoutLoading from '@/app/features/Checkout/CheckoutLoading.vue';
import PageFeedback from '@/shared/components/PageFeedback/PageFeedback.vue';
import FullTemplate from '@/shared/components/Template/Full.vue';
import PaymentFeedback from '@/shared/components/PaymentFeedback/PaymentFeedback.vue';

import Upsell from './Upsell/Upsell.vue';

import {
  EPaymentMethod,
  EOrderSuccessPages,
  EErrorType,
  EErrorScope,
  EErrorSeverity,
  EErrorExhibition
} from '@/helpers/enums';
import { addError } from '@/helpers/errors';

import { Payment } from '@/classes/Checkout/Payment';

import Axios from 'axios';

const AppModule = namespace('App');
const CheckoutModule = namespace('App/Checkout');
const BehaviorModule = namespace('App/Behavior');

@Component({
  components: {
    PageFeedback,
    CheckoutLoading,
    Upsell,
    FullTemplate,
    PaymentFeedback,
  }
})
export default class SuccessPage extends Vue {
  @AppModule.State
  private isPageLoading!: boolean;

  @AppModule.Mutation('setPageLoading')
  private showPageLoading: Function;

  @CheckoutModule.State(state => state.order)
  private order!: any;

  @CheckoutModule.State(state => state.upsell)
  private upsell: IUpsell;

  @CheckoutModule.State(state => state.contract)
  private contract!: any;

  @CheckoutModule.State(state => state.targetContentLink)
  private targetContentLink: ITargetContentLink;

  @CheckoutModule.Action('resolveOrderUpsell')
  private resolveOrderUpsell: Function;

  @CheckoutModule.Action('getContractById')
  private getContractById: Function;

  @CheckoutModule.Getter('selectedOfferPayment')
  private payment!: Payment;

  @BehaviorModule.State
  private purchaseResponse!: any;

  private appLinkUrl: string = '';

  private get currentRouteName(): string|any {
    return this.$router.currentRoute.name;
  }

  private get isContract(): boolean {
    return [EOrderSuccessPages.renewConfirmed, EOrderSuccessPages.renewWaitingPayment].includes(this.currentRouteName);
  }

  private get purchaseData () {
    if(!this.purchaseResponse || !this.purchaseResponse.value) { return null; }

    const purchasedData = JSON.parse(this.purchaseResponse.value);

    const currentPurchaseData = purchasedData.find((purchaseData: any) => {
      return purchaseData.id == this.paramId;
    });

    return currentPurchaseData
      ? currentPurchaseData
      : null;
  }

  private get showUpsell() {
    return this.instructions && this.upsell && !this.upsell.error_code;
  }

  private get instructions () {
    return {
      offer_name: this.contract && this.contract.offer_name,
      ...this.order,
      ...this.contract && {
        ...this.contract.cycle,
        ...this.contract.payment,
        ...this.contract.contract,
      },
      id: this.purchaseData && this.purchaseData.id || this.paramId,
      amount: this.purchaseData && this.purchaseData.amount || this.contract && this.contract.payment.amount || this.order && this.order.amount || 0,
      payment_method_code: this.purchaseData && this.purchaseData.method || this.contract && this.contract.payment.payment_method_code || this.order && this.order.payment_method_code,
      ...this.order && this.order.payment_method_code === EPaymentMethod.bankSlip && {
        bankslip_expiration_days: differenceInBusinessDays(new Date(this.order.bankslip_expires_at), new Date()),
      },
      targetContentLink: this.targetContentLink,
    };
  }

  private get paramId () {
    return this.$route.params.order_id
      || this.$route.params.contract_id;
  }

  private async mounted() {
    window.scrollTo(0, 0);
    this.showPageLoading(false);

    if (!this.order && !this.contract) {
      this.showPageLoading(true);

      try {
        if (!this.isContract) {
          await this.resolveOrderUpsell(this.paramId);
        } else {
          await this.getContractById(this.paramId);
        }

        if (this.instructions.app_link_url) {
          const dynamicRequest = Axios.create({
            baseURL: this.instructions.app_link_url,
          });

          const dynamicResponse = await dynamicRequest.get('');
          this.appLinkUrl = dynamicResponse.data;
        }
      } catch (error) {
        if (error.response) {
          addError(new TraceableError({
            type: EErrorType.loading,
            code: error.response.status,
            scope: EErrorScope.global,
            trigger: 'upsellLoad',
            severity: EErrorSeverity.critical,
            exhibition: EErrorExhibition.none,
          }));
        }
      } finally {
        this.showPageLoading(false);
      }
    }
  }
}
